import { Box, Flex, Text, useMantineTheme, Transition } from '@mantine/core';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  IconHome, 
  IconCategory, 
  IconShoppingBag, 
  IconUser,
  IconSmartHome,
  IconLayoutGrid,
  IconSearch,
  IconUserCircle
} from '@tabler/icons-react';
import { motion, AnimatePresence } from 'framer-motion';

function StickyFooter() {
  const location = useLocation();
  const theme = useMantineTheme();

  const navItems = [
    { label: 'Home', path: '/', icon: IconSmartHome },
    { label: 'Categories', path: '/categories', icon: IconLayoutGrid },
    { label: 'Products', path: '/products', icon: IconShoppingBag },
    { label: 'Account', path: '/account', icon: IconUserCircle },
  ];

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(12px)',
        borderTop: `1px solid ${theme.colors.gray[2]}`,
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 12px)',
        paddingTop: 12,
        height: 'auto',
        width: '100%',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.05)'
      })}
    >
      <Flex align="center" justify="space-around">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{ textDecoration: 'none', position: 'relative' }}
            >
              <Flex direction="column" align="center" gap={4} sx={{ width: 70 }}>
                <Box sx={{ position: 'relative' }}>
                  <AnimatePresence mode="wait">
                    {isActive && (
                      <motion.div
                        layoutId="nav-indicator"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.8, opacity: 0 }}
                        style={{
                          position: 'absolute',
                          top: -6,
                          left: -6,
                          right: -6,
                          bottom: -6,
                          backgroundColor: theme.colors.blue[0],
                          borderRadius: '12px',
                          zIndex: -1
                        }}
                      />
                    )}
                  </AnimatePresence>
                  <item.icon 
                    size={24} 
                    stroke={isActive ? 2.5 : 1.5}
                    color={isActive ? theme.colors.blue[7] : theme.colors.gray[6]} 
                  />
                </Box>
                <Text
                  fz={10}
                  fw={isActive ? 800 : 500}
                  color={isActive ? theme.colors.blue[7] : theme.colors.gray[6]}
                  sx={{ transition: 'color 0.2s ease' }}
                >
                  {item.label}
                </Text>
              </Flex>
            </Link>
          );
        })}
      </Flex>
    </Box>
  );
}

export default StickyFooter;
